import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Password } from 'primeng/password';
import { Message } from 'primeng/message';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'spx-login-page',
  standalone: true,
  imports: [CommonModule, FormsModule, Button, InputText, Password, Message],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginPageComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  email = 'superadmin@sparex.local';
  password = 'Admin@123';
  error = signal<string | null>(null);
  loading = signal(false);

  submit(): void {
    this.loading.set(true);
    this.error.set(null);
    this.auth.login(this.email, this.password).subscribe({
      next: (res) => {
        this.loading.set(false);
        if (res.success) {
          this.router.navigateByUrl('/admin');
        } else {
          this.error.set(res.message || 'Login failed');
        }
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Cannot reach API. Check UAT API is up (uatapispares) and CORS allows this site.');
      }
    });
  }
}
